"use strict";

var _slicedToArray = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/slicedToArray.js");
require("core-js/modules/es.array.sort.js");
exports.isWithinInterval = isWithinInterval;
var _index = require("./toDate.js");

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */
function isWithinInterval(date, interval) {
  var time = +(0, _index.toDate)(date);
  var _sort = [+(0, _index.toDate)(interval.start), +(0, _index.toDate)(interval.end)].sort(function (a, b) {
      return a - b;
    }),
    _sort2 = _slicedToArray(_sort, 2),
    startTime = _sort2[0],
    endTime = _sort2[1];
  return time >= startTime && time <= endTime;
}